<!-- 同步组织架构 【2096】需求 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners">
    <div class="sync-sty">
      <!-- 同步钉钉组织架构 -->
      <el-card class="box-card" :class="{active:orgSyncType == 1}" @click.native="dingSync">
        <img src="/images/icon/dingIcon1.png" alt="icon" class="icon-sty">
        <h2 style="margin: 5px 0;">同步钉钉组织架构</h2>
        <p class="text-sty">实现钉钉组织架构单向同步，仅需在钉钉端维护组织架构信息；在钉钉端执行部门新增、修改或删除操作后，君子签系统将自动同步并完成对应调整。</p>
      </el-card>
      <el-card class="box-card" :class="{active:orgSyncType == 2}" @click.native="selfManage">
        <img src="/images/logoNew.png" alt="" class="icon-sty">
        <h2 style="margin: 5px 0;">自行管理组织架构</h2>
        <p class="text-sty">将基于自身现有组织架构进行独立管理与维护，其组织架构数据与钉钉相互隔离。钉钉端对部门的增删改操作，均不会对组织架构产生任何影响。</p>
      </el-card>
    </div>
  </el-dialog>
</template>

<script>
// API
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
export default {
  props:{
    /** 1：自动同步钉钉组织架构；2：自行管理组织架构 ,无值或者无字段：从未设置过 */
    orgSyncType:{type: Number || Null,default:null}
  },
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    noWay(){
      const msg =  '请前往钉钉客户端安装/访问君子签微应用操作！';
      this.$alert(msg)
    },
    /** 处理同步钉钉组织架构的逻辑 */
    dingSync() {
      if(!isInDingTalk){return this.noWay()}
      const textHTML = `
      <p>将采用“<span style="font-weight: bold;">自动同步钉钉组织架构</span>”模式，是否确认？</p>
      <p style="font-weight: bold;color:#ec1c1c;">确定切换将完全覆盖当前组织架构数据，请慎重操作！</p>
      `;
      this.$confirm(textHTML, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString:true,
        type: 'warning'
      }).then(() => {
        // 确认同步后的逻辑
        this.syncConfirm(1)
      }).catch(() => {
        // 取消同步后的逻辑
      });
    },
    /** 处理自行管理组织架构的逻辑 */
    selfManage() {
      if(!isInDingTalk){return this.noWay()}
      const textHTML =
      `
      <p>将采用“<span style="font-weight: bold;">自行管理组织架构</span>”模式，是否确认？</p>
      <p style="font-weight: bold;color:#ec1c1c;">确定切换将完全覆盖当前组织架构数据，请慎重操作！</p>
      `;
      this.$confirm(textHTML, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString:true,
        type: 'warning'
      }).then(() => {
        // 确认同步后的逻辑
        this.syncConfirm(2)
      }).catch(() => {
        // 取消同步后的逻辑
      });
    },
    syncConfirm(type) {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const {dingTalkCorpId: corpId, dingTalkUserId} = JSON.parse(
        sessionStorage.getItem("dingloginInfo")
      );
      dingtalkApi.orgSyncConfirm({corpId, dingTalkUserId,type}).then(res => {
        if (!res.success) return this.$message.error(res.description);
        this.$message.success('操作成功');
        this.$emit('close');
      }).finally(() => {loading.close()})
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
}
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .sync-sty{
    display: flex;
    justify-content: space-around;
    align-items: center;
    .active{
      box-shadow: 0 2px 12px 0 rgba(236, 28, 26, 0.6);
    }
    .box-card{
      width: 35%;
      /*height: 31vh;*/
      text-align: center;
      cursor: pointer;
      &:hover{
        .active();
      }
      .icon-sty{
        width: 10vw;
      }
      .text-sty{
        text-indent:28px;
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/console/memberManage/components/syncOrganPup.vue